import { common, lightBlue } from '@material-ui/core/colors';

const primary = Object.assign( {}, lightBlue, {
    contrastText: common.white,
    dark: lightBlue[900],
    light: lightBlue[600],
    main: lightBlue[800],
} );
export default primary;
